export default {
  GetInitData: 'GetInitData',
  GetSeatList: 'GetSeatList',
  ReserveTempCartSeats: 'ReserveTempCartSeats',
};
